import React from 'react';
import { graphql, StaticQuery, Link } from 'gatsby';
import { getCurrentLangKey } from 'ptz-i18n';
import { window } from 'browser-monads';

const MenuMobileEn = props => {
	const url = window.location.pathname;
	const { langs, defaultLangKey } = props.data.site.siteMetadata.languages;
	const langKey = getCurrentLangKey(langs, defaultLangKey, url);
	return (
		<div
			id="main-menu-mobile"
			className={`main-menu-mobile ${props.active ? 'open' : ''}`}
		>
			<ul>
				<li>
					<Link to={`${langKey}/`}>HOME</Link>
				</li>
				<li>
					<Link to={`${langKey}/about/`}>ABOUT</Link>
				</li>
				<li>
					<Link to={`${langKey}/contact/`}>CONTACT</Link>
				</li>
				<li>|</li>
				{langs.map(lang => (
					<li key={lang}>
						<Link to={`${lang}/`}>
							{lang == 'sv' ? '🇸🇪' : lang == 'it' ? '🇮🇹' : '🇬🇧'}
						</Link>
					</li>
				))}
			</ul>
		</div>
	);
};

export default props => (
	<StaticQuery
		query={graphql`
			query MenuMobileQueryEn {
				site {
					siteMetadata {
						languages {
							defaultLangKey
							langs
						}
					}
				}
			}
		`}
		render={data => <MenuMobileEn active={props.active} data={data} />}
	/>
);
